const getTableHeaderIntro = () => {
    return `
        const TableHeader = (props) => {
        const { order, orderBy, headCells, selectedSome, selectedAll, onSelectAllClick, onSortClick, hasCheckbox = true, togglePrivacy, privacy, disabledCheckBox = false } = props;
         }
         export default TableHeader;
    `;
}

export default getTableHeaderIntro;
